import { createFileRoute } from '@tanstack/react-router';

import { TasksScreen } from '../features/tasks/TasksScreen';

/**
 * `/tasks` — صفحة المهامّ المستقلّة، بأمر المالك 2026-08-11 وجوابًا على سؤاله
 * «هل توجد صفحة مستقلة للمهام؟». لم تكن؛ لا الصندوق ولا بانتظار هي.
 * ملف المسار رقيق بحكم البنية: التركيب في الميزة.
 */
export const Route = createFileRoute('/tasks')({ component: TasksScreen });
